import { isComicStyle } from './styleTechnique';

/**
 * Does a book's prose belong on its pages (PDF export, print, the reader)?
 *
 * A COMIC is pictures only: the story is in the panels and the balloons the image
 * model letters (comicScript.ts). Printing the block text under a comic page turns
 * it back into a picture book, so every place that lays prose onto a page asks
 * here. The prose itself is not lost — it stays the story's text and the
 * narration (audio is always the full story text).
 *
 * Imports only the leaf style catalogue: safe for client components and server services alike.
 */
export function bookPrintsProse(style: string | null | undefined): boolean {
  return !isComicStyle(style);
}

/** The include-text choice as it is actually applied (and fingerprinted). */
export function effectiveIncludeText(style: string | null | undefined, includeText: boolean): boolean {
  return includeText && bookPrintsProse(style);
}
